import _extends from "@babel/runtime/helpers/extends";
import { msgApi } from '../api';
/**
 * 处理鉴权入参
 * @param {object} data
 * 入参对象 { orgId, agentId, url, type}
 * type:微信鉴权才会用到  ; 为1 时 agentConfig鉴权，其他为config鉴权
*/

var excParams = function excParams(data) {
  var orgId = data.orgId || window.localStorage.orgId || '';
  orgId = orgId.replaceAll('-', '');
  var url = data.url || window.location.href.split('#')[0];
  return _extends({}, data, {
    orgId: orgId,
    url: url
  });
};
/**
 * 获取微信自建应用的鉴权配置 wx.config
 * @param {object} data
 * 入参对象 { orgId, agentId, url, type}
 * type  1为 agentConfig鉴权，其他为config鉴权
 * @returns Promise
 */


export var loadWxConfig = function loadWxConfig(data) {
  var params = excParams(data);
  if (!params.orgId) return Promise.resolve(false);
  return msgApi.post('wechat/js/crop/config', params);
};
/**
 * 获取微信服务号/公众号的鉴权配置 wx.config
 * @param {object} data
 * 入参对象 { orgId, url }
 * @returns Promise
 */

export var loadWxServeConfig = function loadWxServeConfig(data) {
  var _excParams = excParams(data),
      orgId = _excParams.orgId,
      url = _excParams.url;

  if (!orgId) return Promise.resolve(false);
  return msgApi.post('wechat/js/public/config', {
    orgId: orgId,
    url: url
  });
};
/**
 * 获取企业微信自建应用的鉴权配置 wx.agentConfig
 * @param {object} data
 * 入参对象 { orgId, agentId, url, type}
 * type  1为 agentConfig鉴权，其他为config鉴权
 * @returns Promise
 */

export var loadWxAgentConfig = function loadWxAgentConfig(data) {
  return loadWxConfig(_extends({}, data, {
    type: 1
  }));
};
/**
 * 获取钉钉自建应用的鉴权配置
 * @param {object} data
 * 入参对象 { orgId, agentId, url, type}
 * @returns Promise
 */

export var loadDingTalkConfig = function loadDingTalkConfig(data) {
  var params = excParams(data);
  if (!params.orgId) return Promise.resolve(false);
  return msgApi.post('ding/js/config', params);
};